import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import WatchlistNotesTable from "../../../../components/ui/WatchlistNotesTable";
import { ComplianceAPI } from "../../../../api/compliance";
import { fundedComplianceActions } from "../../../../reducers/FundedCompliance";
import { getWatchlistNotesColumns } from "../../../FundedComplianceProfile/components/WatchlistNotes/getWatchlistNotesColumns";

const WatchlistNotes = (): React.ReactElement => {
  const { watchlistNotes } = useSelector((state) => state.fundedCompliance);
  const { rows } = watchlistNotes.data.results;

  const getInitialValues = useMemo(
    () => (editIds: number[]) => {
      const noteToEdit = rows.find((note) => note.id === editIds[0]);

      return {
        reason: noteToEdit?.reason || "",
        measure_taken: noteToEdit?.measure_taken || "",

        email: noteToEdit?.account?.email,
        assignedEmail: noteToEdit?.account?.email,
      };
    },
    [rows]
  );

  const getColumns = useMemo(
    () => (onEditNote: (ids: number[]) => void) =>
      getWatchlistNotesColumns({
        onEditNote,
        withCustomerDataColumns: true,
      }),
    []
  );

  return (
    <WatchlistNotesTable
      rows={rows}
      isLoading={watchlistNotes.isLoading}
      onFetchNotes={async (query, signal) =>
        await ComplianceAPI.getSearchNotes(query.toString(), signal)
      }
      onFetchRequest={() => fundedComplianceActions.fetchWatchlistNotesRequest()}
      onFetchSuccess={(data) => fundedComplianceActions.fetchWatchlistNotesSuccess(data)}
      onFetchError={() => fundedComplianceActions.fetchWatchlistNotesFailed()}
      getInitialValues={getInitialValues}
      getColumns={getColumns}
      queryKey={[]}
      withEmailSelect
    />
  );
};

export default WatchlistNotes;
